<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Produk Serial</div>
		</div>
		<div v-if="loading">
			<!-- <loading-card></loading-card> -->
		</div>
		<div>
			<v-card class="mt-3 mb-3" outlined>
				<v-list color="deep-purple lighten-5" class="pa-3">
					<v-list-item dense class="px-1">
						<v-row>
							<v-col cols="4" md="4">
								<v-autocomplete outlined dense hide-details v-model="card_type" :items="listCardType" label="Tipe Kartu" no-data-text="Tidak ada data yang sesuai" @change="changeCardType"></v-autocomplete>
							</v-col>
							<v-spacer></v-spacer>
							<v-btn text depressed class="primary mr-2" @click="exportData">
								<v-icon>mdi-export</v-icon>
								<div class="pl-2 text-capitalize">Export</div>
							</v-btn>
							<v-btn depressed class="primary mr-2" @click="dropfilter = !dropfilter">
								<v-icon>mdi-filter</v-icon>
								<div class="pl-2 text-capitalize">Filter</div>
							</v-btn>
						</v-row>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mt-3 mb-3" v-if="dropfilter">
					<v-col class="px-4 py-1">
						<v-row>
							<v-col cols="4" md="4">
								<v-autocomplete outlined dense hide-details v-model="card_availability" :items="listCardAvailability" label="Ketersediaan Kartu" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="4" md="4">
								<v-text-field dense outlined hide-details label="Kode Serial" v-model="serial_code"></v-text-field>
							</v-col>
							<v-col cols="4" md="4">
								<v-text-field dense outlined hide-details label="ID Pembeli (GS)" v-model="buyer"></v-text-field>
							</v-col>
							<v-col cols="4" md="4">
								<v-text-field dense outlined hide-details label="ID Pemilik (GS)" v-model="owner"></v-text-field>
							</v-col>
							<v-col cols="4" md="4">
								<v-menu v-model="menubuydate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(buydate)" label="Tanggal Pembelian" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker range color="primary" v-model="buydate"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="4" md="4">
								<v-menu v-model="menuusedate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(usedate)" label="Tanggal Digunakan" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker range color="primary" v-model="usedate"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="4" md="4">
								<v-text-field dense outlined hide-details label="Pengguna Serial" v-model="user"></v-text-field>
							</v-col>
							<v-col cols="12" md="12" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter">Reset</v-btn>
								<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<v-btn text depressed class="mr-2 mb-2" :class="val.type_id == type_serial ? 'primary' : 'deep-purple lighten-5'" @click="changeSerialType(val.type_id)" v-for="(val, index) in listSerialType" :key="index">
				<div class="pl-2 text-capitalize">{{ val.type_name }}</div>
			</v-btn>
			<v-card outlined class="mt-3">
				<v-data-table loading :headers="headers" dense :items="serialProductResults" hide-default-footer :options.sync="option" :server-items-length="serialProductPagination.total_data" disable-pagination>
					<template v-slot:item.buydate="{ item }">
						<div class="pb-2">{{ item.buydate | tanggalIna }}</div>
					</template>
					<template v-slot:item.expired_date="{ item }">
						<div class="pb-2">{{ item.expired_date | tanggalIna }}</div>
					</template>
					<template v-slot:item.usedate="{ item }">
						<div class="pb-2">{{ item.usedate | tanggalIna }}</div>
					</template>
					<template v-slot:progress>
						<div>
						</div>
					</template>
					<template v-slot:loading>
						<div class="py-3" v-if="!serialProductPagination">
							<loading-data></loading-data>
						</div>
						<div class="py-3" v-else>
							<not-found></not-found>
						</div>
					</template>
				</v-data-table>
			</v-card>
			<div class="pt-5">
				<v-row v-if="serialProductPagination">
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination @input="changePage" v-model="page" :length="serialProductPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" @input="changeLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState, mapMutations } from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			dropfilter: false,
			menubuydate: false,
			menuusedate: false,
			loading: true,
			tanggalPO: [],
			po_code: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'po_code'
			},
			po_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'po_status_created_datetime'
			},
			supplier: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'po_supplier_id'
			},
			sortBy: '',
			sortDir: 'DESC',
			page: 1,
			limit: '100',
			listLimit: [ '50', '100', '200', '500' ],
			headers: [
			{ text: 'Kode Serial', value: 'serial' },
			{ text: 'Pembeli Serial', value: 'buyer', sortable: true},
			{ text: 'Tanggal Pembelian', value: 'buydate'},
			{ text: 'Tanggal Kadaluarsa', value: 'expired_date'},
			{ text: 'Tanggal Digunakan', value: 'usedate'},
			{ text: 'Pemilik Serial', value: 'serial_owner'},
			{ text: 'Pengguna Serial', value: 'user'},
			{ text: 'Point BV', value: 'serial_bv'},
			{ text: 'Tipe Serial', value: 'serial_card_type'},
			],
			params:[],
			buydate: [],
			usedate: [],
			card_type: 2,
			card_availability: 0,
			serial_code: '',
			buyer: '',
			owner: '',
			user: '',
			type_serial: 1,
			listCardAvailability: [{
				text: 'Semua',
				value: 0
			}, {
				text: 'Tersedia',
				value: 1
			}, {
				text: 'Tidak Tersedia',
				value: 2
			}]
		}
	},
	computed: {
		...mapState('productSerial', ['serialProductResults', 'serialProductPagination', 'serialType']),
		...mapState('auth', ['userData']),

		listSerialType() {
			if (this.userData.user_type == 'superuser') {
				return this.serialType.filter( el => {
					return el.type_id > 0
				})
			} else {
				return this.serialType.filter( el => {
					return el.type_id > 2
				})
			}
		},
		listCardType() {
			//if (this.userData.user_type == 'superuser') {
				return [{
					text: 'Fisik', value: 1
				}, {
					text: 'Digital',
					value: 2
				}]
			// } else {
			// 	return [{
			// 		text: 'Digital',
			// 		value: 2
			// 	}]
			// }
		},
		dateBuy() {
			var tanggal = []
			if (this.buydate.length > 0) {
				tanggal = this.buydate
				tanggal.sort((a, b) => new Date(a) - new Date(b))
				if (tanggal.length < 2) {
					tanggal.push(tanggal[0])
				}
			}
			return tanggal
		},
		dateUsed() {
			var tanggal = []
			if (this.usedate.length > 0) {
				tanggal = this.usedate
				tanggal.sort((a, b) => new Date(a) - new Date(b))
				if (tanggal.length < 2) {
					tanggal.push(tanggal[0])
				}
			}
			return tanggal
		}
	},
	methods: {
		...mapActions('productSerial', ['getSerialProduct', 'exportSerialProduct', 'getSerialTypeOption']),
		...mapMutations('productSerial', ['clearDataPO', 'listSerialProduct']),

		async getData() {
			await this.listSerialProduct({
				data: [],
				pagination: ''
			})
			let filter = await this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})
			filter['card_type'] = await this.card_type
			filter['type'] = await this.type_serial
			filter['availablilty'] = await this.card_availability
			filter['serial'] = await this.serial_code
			filter['buyer'] = await this.buyer
			filter['owner'] = await this.owner
			filter['user'] = await this.user
			filter['buydate'] = await this.dateBuy
			filter['usedate'] = await this.dateUsed
			await this.getSerialProduct(filter)
		},
		cari() {
			this.page = 1
			this.getData()
		},
		changeCardType() {
			this.getData()
		},
		changeSerialType(val) {
			this.type_serial = val
			this.page = 1
			this.getData()
		},
		async exportData() {
			let filter = await this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir})
			filter['card_type'] = await this.card_type
			filter['type'] = await this.type_serial
			filter['availablilty'] = await this.card_availability
			filter['serial'] = await this.serial_code
			filter['buyer'] = await this.buyer
			filter['owner'] = await this.owner
			filter['user'] = await this.user
			filter['buydate'] = await this.dateBuy
			filter['usedate'] = await this.dateUsed
			await this.exportSerialProduct(filter)
		},
		resetFilter() {
			this.card_availability = 0
			this.serial_code = ''
			this.buyer = ''
			this.owner = ''
			this.user = ''
			this.page = 1
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Produk Serial`)
		this.getData()
		this.getSerialTypeOption()
	},
	beforeDestroy() {
		// this.clearDataPO()
	},
	watch: {
		tanggalPO(val) {
			this.po_date.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getPO(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		}
	}
};
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
</style>